export const MODULE_PATH = "support"

export const SUPPORT_HOME = `/s/${MODULE_PATH}`
export const ISSUE_CREATE = `/s/${MODULE_PATH}/issue/create`
export const ISSUE_TRAVEL_DETAIL = `/s/${MODULE_PATH}/issue/travel`
